import { patientActions } from '#store/slices/patientSlice';

export const { setPatient } = patientActions;
